export default __webpack_public_path__ + "static/Entenda0052-ef18d0cb60439b6cb6743bd0b0e035d8.jpg";